import Loandetailsactiveview from "../../../jsx/components/Dashboard/LoanDetails/loandetailsactiveview";

const LoanDetailsActiveViewWrapper = () => {
  return <Loandetailsactiveview />;
};

export default constore(LoanDetailsActiveViewWrapper);
